<template>
    <div
        class="tooltip-on-hover"
        :class="[additionalClass, dark ? 'dark' : false, reverse ? 'reverse' : false]"
        :style="getRootStyle()"
    >
        <slot></slot>
        <div class="tooltip-on-hover-triangle" :style="getTriangleStyle()"></div>
    </div>
</template>

<script>
export default {
    name: "TooltipOnHover",
    props: {
        additionalClass: String,
        toTop: Number,
        isLeft: Boolean,
        dark: Boolean,
        reverse: Boolean,
        toHorizontal: Number,
        triangleLeft: Boolean,
        triangleRight: Boolean,
        textAlign: String,
        width: Number,
        whiteSpace: String,
        showTooltip: Boolean
    },
    methods: {
        getTriangleStyle() {
            const style = {}

            /*if (this.toHorizontal) {
                style.transform = `translateX(${-this.toHorizontal / 2 - 10}px) !important`
            }*/

            if (this.triangleLeft) {
                style.transform = `none !important`
                style.left = `20px !important`
            }

            if (this.triangleRight) {
                style.transform = `none !important`
                style.left = `calc(100% - 30px) !important`
                //style.right = `20px !important`
            }

            if (this.isLeft) {
                style.display = `none !important`
            }

            return style
        },
        getRootStyle() {
            const style = {
                //top: this.toTop && `${this.toTop}px`,
                textAlign: this.textAlign && this.textAlign,
                width: this.width && `${this.width}px`,
                whiteSpace: this.whiteSpace && this.whiteSpace
            }

            if (this.triangleLeft) {
                style.transform = `translate(-25px, -20px)`
                style.left = `50%`
                style.right = `auto`
            }

            if (this.isLeft) {
                style.transform = `translate(calc(100%), 0%)`
                style.left = `auto`
                style.right = `10px`
                style.bottom = `auto`
            }

            if (this.triangleRight) {
                style.transform = `translate(25px, -20px)`
                style.left = `auto`
                style.right = `50%`
            }

            /*if (this.toHorizontal) {
                style.left = `${this.toHorizontal}px !important`
            }*/

            if (this.showTooltip) {
                style.opacity = this.showTooltip ? 1 : 0
            }

            return style
        }
    }
}
</script>

<style lang="sass">
.show-tooltip-on-hover, .editor-button
    position: relative
    &:hover
        .tooltip-on-hover
            opacity: 1

.tooltip-on-hover.open
    opacity: 1
    pointer-events: all
.tooltip-on-hover
    position: absolute
    top: auto
    bottom: 50%
    left: 50%
    transform: translate(-50%, -20px)
    background-color: #fff
    border-radius: 10px
    max-width: 400px
    line-height: 130%
    font-size: 12px
    color: #52565C
    padding: 6px 14px
    z-index: 9999999999
    pointer-events: none
    opacity: 0
    transition: 250ms
    text-transform: initial !important
    margin-left: 0 !important
    width: max-content
    filter: drop-shadow( 0 4px 10px rgba(128, 158, 191, 0.15))
    .tooltip-on-hover-triangle
        content: ""
        position: absolute
        top: calc(100% - 1px)
        left: 50%
        transform: translateX(-50%)
        border: 7px solid transparent
        border-top-color: #fff
    @media screen and (max-width: 960px)
        // left: -15px
        &:after
            left: 25px
    &__subtitle,
    &__text
        font-weight: 400
        font-size: 12px
        line-height: 160%

    &__subtitle
        color: #52565C
    &__text
        color: #151515
    &.dark
        color: #fff
        background-color: #505050
        .tooltip-on-hover-triangle
            border-top-color: #505050
    &.reverse
        border-radius: 0
        transition: 0s !important
        .tooltip-on-hover-triangle
            top: -12px
            left: 50%
            transform: translateX(-50%) rotate(180deg)
</style>
